import React from "react";
import Spark from "@/components/brand/Spark";
import Reveal from "@/components/site/Reveal";

/**
 * Editorial "by the numbers" strip — uses framework facts, NOT invented metrics.
 */
export const StatsStrip = ({ items, testid }) => (
  <section
    className="bg-[#FBF9F4] border-y border-[#2A2422]/8 py-14 md:py-16"
    data-testid={testid}
  >
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 items-stretch">
        {items.map((it, i) => (
          <Reveal key={it.label} delay={i * 80}>
            <div className="flex md:flex-col items-center md:items-start md:text-left text-center gap-4 md:gap-2 md:border-l md:border-[#2A2422]/15 md:pl-6">
              <p className="font-display text-[3.2rem] md:text-[3.6rem] leading-none text-[#2A2422]">
                {it.value}
              </p>
              <div className="md:mt-3 flex items-center gap-2">
                <Spark size={12} />
                <p className="eyebrow text-[#6E735B]">{it.label}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default StatsStrip;
